import React from 'react';
import cn from 'classnames';
import { bool } from 'prop-types';

const propTypes = {
  isInner: bool,
  isInButton: bool,
  small: bool,
};

const Loader = ({ isInner, isInButton, small, isInButtonCenter }) => {
  const classes = cn(
    'loader-wrapper',
    { inner: isInner },
    { 'in-button': isInButton },
    { small: small },
    { 'in-button-center': isInButtonCenter },
  );

  return (
    <div className={classes}>
      <div className="loader" />
    </div>
  );
};

Loader.propTypes = propTypes;

export default Loader;
